import React from 'react';
import { PropTypes } from 'prop-types';
import UserAccount from '../../services/UserAccount';
import WindowSize from '../../services/WindowSize';
import { isPasswordInvalid } from '../../utils/regex';
import LogictryComponent from '../../submodules/logictry_config/LogictryComponent';
import { Form, Input, InputWrapper, PrimaryButton, Title, WarningText, DialogActions, CancelButton, ConfirmButton } from '../../styledhtml/Tailwind';

export default class ChangePassword extends LogictryComponent {
  static propTypes = {
    email: PropTypes.string,
    changePassword: PropTypes.bool,
    onComplete: PropTypes.func,
    onCancel: PropTypes.func,
  };

  constructor(props) {
    super(props);
    this.state = { password: '', passwordAgain: '', warning: '' };
  }

  submitPressed = () => {
    const { password, passwordAgain } = this.state;

    if (!password) return this.setState({ warning: 'New Password blank' });
    if (password !== passwordAgain)
      return this.setState({ warning: 'Passwords must match' });

    if (isPasswordInvalid(password))
      return this.setState({
        warning: 'Invalid password — must be 8 to 30 characters',
      });

    UserAccount.updatePassword(this.props.email, password);
    if (this.props.onComplete) this.props.onComplete();
  };

  render() {
    const { password, passwordAgain, warning } = this.state;
    const { changePassword, onCancel } = this.props;

    const submitButton = changePassword && onCancel ? (
      <ConfirmButton onClick={this.submitPressed}>
        Update Password
      </ConfirmButton>
    ) : (
      <PrimaryButton onClick={this.submitPressed}>
        {changePassword ? 'Update Password' : 'Set Password'}
      </PrimaryButton>
    );

    return (
      <>
        <Title>{changePassword ? 'Change Password' : 'Set Password'}</Title>

        <Form>
          <InputWrapper>
            <Input
              placeholder={changePassword ? 'New Password' : 'Password'}
              type="password"
              value={password}
              onChange={(e) => this.setState({ password: e.target.value.replaceAll(' ', '') })}
              autoFocus={!WindowSize.mobile}
            />
          </InputWrapper>

          <InputWrapper>
            <Input
              placeholder={changePassword ? 'New Password Again' : 'Password Again'}
              type="password"
              value={passwordAgain}
              onChange={(e) =>
                this.setState({ passwordAgain: e.target.value.replaceAll(' ', '') })
              }
              onKeyDown={(e) => e.key === 'Enter' && this.submitPressed()}
            />
          </InputWrapper>

          {onCancel ? (
            <DialogActions>
              <CancelButton onClick={onCancel}>Cancel</CancelButton>
              {submitButton}
            </DialogActions>
          ) : (
            submitButton
          )}

          <WarningText>{warning}</WarningText>
        </Form>
      </>
    );
  }
}
